import $ from 'jquery'
import 'slick-carousel/slick/slick.min.js'

$(document).ready(function () {
  $('.inspirationBlocks__sliderWrapper--slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          // variableWidth: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          // variableWidth: false
        }
      }
    ]
  })
})
